export default "/assets/images/technology-graph-06.svg?7d597c1ecc2cd75ea2d61182fb4bdc45";